// src/shared/types/customer.ts

export const CUSTOMER_TYPES = {
  adtech: 'adtech',
  affiliate: 'affiliate',
  ssp: 'ssp',
  dsp: 'dsp',
  creator: 'creator',
} as const;
export type TUserCustomerType =
  (typeof CUSTOMER_TYPES)[keyof typeof CUSTOMER_TYPES];

export const CUSTOMER_STATUS = {
  live: 'live',
  demo: 'demo',
  registered: 'registered',
  kyc: 'kyc',
  suspended: 'suspended',
} as const;

export type TCustomerStatus =
  (typeof CUSTOMER_STATUS)[keyof typeof CUSTOMER_STATUS];

export const CUSTOMER_KYC_STATUS = {
  passed: 'passed',
  under_review: 'under_review',
  rejected: 'rejected',
} as const;
export type TCustomerKycStatus =
  (typeof CUSTOMER_KYC_STATUS)[keyof typeof CUSTOMER_KYC_STATUS];

export function isDemoCustomer(
  customer: { is_demo: boolean; status: TCustomerStatus } | null | undefined,
): boolean {
  if (!customer) return false;
  return customer.is_demo || customer.status === CUSTOMER_STATUS.demo;
}
